module.exports = __webpack_public_path__ + "img/secondary-4.626a9947.svg";